  if (!customElements.get('custom-buy-now')) {
    class CustomBuyNow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-buy-now-button]');

        if (!this.button) return;

        this.form = document.getElementById(this.dataset.formId);

        if (!this.form) {
          console.warn('Custom Buy Now: product form not found');
          return;
        }

        this.handleClick = this.handleClick.bind(this);
        this.handlePageShow = this.handlePageShow.bind(this);

        this.button.addEventListener('click', this.handleClick);

        /*
         * Reset the button when returning to this page
         * with the browser back button.
         */
        window.addEventListener('pageshow', this.handlePageShow);

        /*
         * Also reset it immediately when the component loads.
         */
        this.setLoadingState(false);
      }

      disconnectedCallback() {
        if (this.button && this.handleClick) {
          this.button.removeEventListener('click', this.handleClick);
        }

        if (this.handlePageShow) {
          window.removeEventListener('pageshow', this.handlePageShow);
        }
      }

      handlePageShow() {
        this.setLoadingState(false);
      }

      async handleClick() {
        if (this.button.disabled) return;

        this.setLoadingState(true);

        try {
          const clearResponse = await fetch(
            window.Shopify.routes.root + 'cart/clear.js',
            {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!clearResponse.ok) {
            throw new Error('Unable to prepare checkout.');
          }

          const formData = new FormData(this.form);

          const addResponse = await fetch(
            window.Shopify.routes.root + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                Accept: 'application/json'
              },
              body: formData
            }
          );

          const result = await addResponse.json();

          if (!addResponse.ok) {
            throw new Error(
              result.description ||
              'Unable to add this product to checkout.'
            );
          }

          window.location.href =
            window.Shopify.routes.root + 'checkout';
        } catch (error) {
          console.error('Buy it now error:', error);

          this.setLoadingState(false);
        }
      }

      setLoadingState(isLoading) {
        if (!this.button) return;

        this.button.disabled = isLoading;

        /*
         * Prevent the loading state from remaining visually active
         * when returning with the browser Back button.
         */
        this.button.setAttribute(
          'aria-busy',
          isLoading ? 'true' : 'false'
        );
      }
    }

    customElements.define('custom-buy-now', CustomBuyNow);
  }